import type { LicenseType } from "@/data-access/user/meTenantLicenseTypes";

export type { LicenseType };

export interface Tenant {
  id: number;
  name: string;
  slug: string;
  website: string;
  owner: number | null;
  logo: string | null;
  active_license_types: LicenseType[];
}

export interface FeedLastLocation {
  feed_id: string;
  surface: "ANALYSIS" | "DISCOVERY";
  location: string;
  updated_at: string;
}

export interface UserInfo {
  id: number;
  name: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  avatar?: string | null;
  last_visited_location?: string | null;
  feed_last_locations?: FeedLastLocation[];
  date_joined: string;
  position?: string;
  expectation?: string;
  expectationUpdated?: string;
  isExpectationUpdated?: boolean;
  walkthrough_completed?: boolean;
  tenants?: Tenant[];
  default_tenant_id: number;
  default_tenant: Tenant;
}

export const defaultUserInfo: UserInfo = {
  id: 0,
  name: "",
  username: "",
  email: "",
  first_name: "",
  last_name: "",
  date_joined: "",
  isExpectationUpdated: false,
  walkthrough_completed: false,
  default_tenant_id: 0,
  default_tenant: {
    id: 0,
    name: "",
    slug: "",
    website: "",
    owner: null,
    logo: null,
    active_license_types: [],
  },
};
